export type ExpiringStockTrackerStatus =
    | 'ACTIVE'
    | 'DEACTIVATED_STOCK_DEPLETED'
    | 'DEACTIVATED_EXPIRED'
    | 'DEACTIVATED_MANUAL'
    | 'ARCHIVED';

export const EXPIRING_STOCK_DEACTIVATED_STATUSES: ExpiringStockTrackerStatus[] = [
    'DEACTIVATED_STOCK_DEPLETED',
    'DEACTIVATED_EXPIRED',
    'DEACTIVATED_MANUAL',
];

export type ExpiringStockPromoStatus =
    | 'NONE'
    | 'ACTIVE'
    | 'DEACTIVATED_KONNECT'
    | 'DEACTIVATED_KORONA';

export type ExpiringStockPromoType = 'IMMEDIATE_DISCOUNT' | 'COUPON_DISCOUNT';

export type ExpiringStockBenefitType =
    | 'COMMON'
    | 'EXTENDED'
    | 'REDUCE_PRODUCT_AMOUNT'
    | 'GRADUATED_DISCOUNT';

export interface ExpiringStockProduct {
    uuid: string;
    name: string;
    number: string;
}

export interface ExpiringStockLocation {
    id: number;
    name: string;
}

export interface ExpiringStockOrgUnit {
    uuid: string;
    name: string;
}

export interface ExpiringStockPromoTemplate {
    id: number;
    business: number;
    name: string;
    promo_type: ExpiringStockPromoType;
    benefit_type: ExpiringStockBenefitType;
    benefit_config: Record<string, unknown>;
    trigger_config: Record<string, unknown>;
    promo_name_template: string;
    receipt_info_text_template: string | null;
    is_default: boolean;
    created_at: string;
    updated_at: string;
}

export interface ExpiringStockTracker {
    id: number;
    business: number;
    product: ExpiringStockProduct;
    location: ExpiringStockLocation | null;
    organizational_unit: ExpiringStockOrgUnit | null;
    promo_template: ExpiringStockPromoTemplate | null;
    initial_expiring_count: number;
    current_remaining_count: number;
    total_sold: number;
    product_expiry_date: string;
    promo_korona_uuid: string | null;
    promo_name: string;
    promo_validity_end: string | null;
    status: ExpiringStockTrackerStatus;
    promo_status: ExpiringStockPromoStatus;
    activated_at: string;
    deactivated_at: string | null;
    notes: string | null;
    external_coupon_number: string | null;
}

export interface ExpiringStockTrackerCreatePayload {
    business: number;
    product: string;
    location: number;
    organizational_unit?: string | null;
    promo_template?: number | null;
    initial_expiring_count: number;
    product_expiry_date: string;
    promo_korona_uuid?: string | null;
    promo_name?: string;
    notes?: string | null;
}

export interface KoronaPromotion {
    id: string;
    name: string;
    number: string;
    revision?: number;
    active: boolean;
    type: string;
    benefitType: string | null;
    validFrom: string | null;
    validTo: string | null;
    organizationalUnits: { id: string }[];
}

export interface ExpiringStockPromoPreviewResult {
    promo_name: string;
    receipt_info_text: string | null;
}
